import { RouteObject } from 'react-router-dom'
import RequiredExpertCreation from '../../components/User/requiredExpert/RequiredExpertCreation'
import ContactCallout from '../../components/Contact/List/ContactCallout'
import ContactList from '../../components/Contact/List/ContactList'
import Preferences from '../../components/preferences/Preferences'
import { CaregiverList } from '../../components/User/CaregiverList/CaregiverList'
import Password from '../../components/User/Password'
import WorkbenchCallout from '../../components/workbench/WorkbenchCallout'
import WorkbenchPatientList from '../../components/workbench/WorkbenchPatientList'
import Main from '../../layouts/Main'
import RouterError from '../RouterError'
import { LegacyHcsProvider } from '../../components/legacy/LegacyHcsProvider'
import { EstablishmentContainer } from '../../components/Establishment/EstablishmentContainer'
import { CaregiverCreation } from '../../components/User/CaregiverCreation'
import { CaregiverEdition } from '../../components/User/CaregiverEdition'
import { AdminGuard } from '../guards/adminGuard'

export const adminRoutes: RouteObject = {
    path: '/',
    element: <AdminGuard />,
    children: [
        {
            path: '/',
            errorElement: <RouterError />,
            children: [
                {
                    path: '/establishment',
                    element: (
                        <Main title="Gestion de l'établissement" goBackTo="/">
                            <EstablishmentContainer />
                        </Main>
                    ),
                },
                {
                    path: '/preferences',
                    element: (
                        <Main title="Gestion des préférences" goBackTo="/">
                            <LegacyHcsProvider>
                                <Preferences />
                            </LegacyHcsProvider>
                        </Main>
                    ),
                },
                {
                    path: '/users',
                    element: (
                        <Main title="Liste des utilisateurs de l’établissement" goBackTo="/">
                            <CaregiverList />
                        </Main>
                    ),
                },
                {
                    path: '/contacts',
                    element: (
                        <Main title="Liste des correspondants" callout={<ContactCallout />} goBackTo="/">
                            <ContactList />
                        </Main>
                    ),
                },
                {
                    path: '/patients-workbench',
                    element: (
                        <Main
                            title="Liste des identités INS en attente de traitement"
                            goBackTo="/patients"
                            callout={<WorkbenchCallout />}
                        >
                            <WorkbenchPatientList />
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/user',
            errorElement: <RouterError />,
            children: [
                {
                    path: '/user/',
                    element: (
                        <Main title="Ajouter un utilisateur" goBackTo="/users" noBackground>
                            <CaregiverCreation />
                        </Main>
                    ),
                },
                {
                    path: '/user/:id',
                    element: (
                        <Main title="Modifier un utilisateur" goBackTo="/users" noBackground>
                            <CaregiverEdition />
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/user-password/',
            errorElement: <RouterError />,
            children: [
                {
                    path: '/user-password/:id',
                    element: (
                        <Main>
                            <Password />
                        </Main>
                    ),
                },
            ],
        },
        {
            path: '/expert',
            errorElement: <RouterError />,
            children: [
                {
                    path: '/expert/',
                    element: (
                        <Main goBackTo="/network" title="Ajouter un téléconsultant" noBackground>
                            <RequiredExpertCreation />
                        </Main>
                    ),
                },
            ],
        },
    ],
}
